// Mounts the platform-provided nomenclature-type list at
// /admin/nomenclature. Each type row expands inline to its items
// sub-table (platform's row-expansion). `staticData.nav` registers the
// sidebar entry via the auto-derived Navigation component.

import { nomenclatureTypeListRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/nomenclature/')({
  ...nomenclatureTypeListRoute,
  staticData: {
    nav: { label: 'Nomenclatures', order: 25, group: 'Admin' },
    breadcrumb: 'Nomenclatures',
  },
})
